module.exports = __webpack_public_path__ + "img/hzhs4.9f3f77c9.jpg";